import React, {useState} from 'react';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { InfoSection } from '../components/InfoSection';
import { homeObjOne, homeObjThree, homeObjTwo } from '../components/InfoSection/Data';
import Footer from '../components/Footer';
import Services from '../components/Services';
import Contactme from '../components/Contactmeform';
import ServicePackages from '../components/ServicePackages';
import Testimonials from '../components/Testimonials';
import ItCheck from '../components/ITCheck/ItCheck';

const Home = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggle = () => {
        setIsOpen(!isOpen);
    };

  return (
    <>
        <Sidebar isOpen={isOpen} toggle={toggle} />
        <Navbar toggle={toggle}/>
        <HeroSection /> 
        <InfoSection {...homeObjOne}/>
        <InfoSection {...homeObjTwo}/>
        <Services />
        <ServicePackages />
        <ItCheck />
        <InfoSection {...homeObjThree}/>
        <Contactme />
        <Testimonials />
        <Footer />
    </>
  );
};

export default Home;